import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconCapsule = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M30.825 11.401a.5.5 0 0 1 .5-.5 5.004 5.004 0 0 1 4.998 4.998.5.5 0 1 1-1 0 4.003 4.003 0 0 0-3.998-3.998.5.5 0 0 1-.5-.5M16.671 9.572a6.334 6.334 0 0 0-6.327 6.327V24h8.403v-6.35a.5.5 0 1 1 1 0V24h3.252v-8.1a6.334 6.334 0 0 0-6.328-6.328m0 26.527a4.003 4.003 0 0 1-3.997-3.998.5.5 0 1 0-1 0 5.004 5.004 0 0 0 4.998 4.998.5.5 0 1 0 0-1M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-9.347-1.415V15.9a7.327 7.327 0 1 0-14.654 0 7.327 7.327 0 1 0-14.655 0v16.202A7.327 7.327 0 1 0 24 32.1a7.327 7.327 0 1 0 14.654 0zm-9.403 7.766a.5.5 0 1 1-1 0V24h-3.251v8.1c0 3.49 2.838 6.328 6.327 6.328s6.327-2.839 6.327-6.327V24H29.25z',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconCapsule)
export default ForwardRef
